import { widthOfDeviceIsMobile } from 'utils'

export default {
  data() {
    return {
      isMobile: false,
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },

  created() {
    this.isMobile = widthOfDeviceIsMobile()
  },

  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_resizeHandler() {
      if (!document.hidden) {
        this.isMobile = widthOfDeviceIsMobile()
      }
    }
  }
}